import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';

interface MessageBodyProps extends BoxProps {
  isMe: boolean;
  children: React.ReactNode;
}

export function MessageBody({ isMe, children, ...props }: MessageBodyProps) {
  return (
    <Box
      className="MessageBody"
      display="flex"
      minW="0"
      maxW="calc(100% - 100px)"
      flexDirection="column"
      alignItems={isMe ? 'flex-end' : 'flex-start'}
      {...props}
    >
      {children}
    </Box>
  );
}
